import { useReducer } from 'react';
import { useMemorizedCacheTag } from '../../../../hooks/useMemorizedCacheTag';
import { loadingReducer, loadingReducerInitialState } from '../../../../reducer/loadingReducer';
import {
  useCreateLessonInTimetableVersionMutation,
  useUpdateLessonMutation,
} from '../../../../types/planung-graphql-client-defs';
import { LessonFormType, VersionLessonFormType } from '../../types';
import { toCardDurations, toLessonInput } from '../../utils/buildLessonInput';

/**
 * Zuordnungen, die es nur in einer Stundenplan-Version gibt: anlegen (samt ungesteckter Karten) und ändern.
 */
export function useTimetableLessons({ schoolYearUuid, versionUuid }: { schoolYearUuid: string; versionUuid?: string }) {
  const [, dispatch] = useReducer(loadingReducer, loadingReducerInitialState);

  const context = useMemorizedCacheTag('LESSONS');

  const [, create] = useCreateLessonInTimetableVersionMutation();
  const [, update] = useUpdateLessonMutation();

  const createLesson = async (values: VersionLessonFormType | LessonFormType) => {
    const result = await create({
      versionUuid: versionUuid ?? '',
      schoolYearUuid,
      input: toLessonInput(values),
      cardDurations: toCardDurations(values),
    });
    return { error: result.error, data: result.data?.createLessonInTimetableVersion };
  };

  const updateLesson = async (values: VersionLessonFormType | LessonFormType) => {
    dispatch({ type: 'SET_LOADING', uuids: [values.uuid ?? 'all'] });
    const result = await update({ uuid: values.uuid ?? '', input: toLessonInput(values) }, context);
    dispatch({ type: 'RESET' });
    return { error: result.error, data: result.data?.updateLesson };
  };

  return {
    createLesson,
    updateLesson,
    lessonContext: context,
  };
}
